// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { ApiError } from "@granite/api-client";

import { isMessageKey, t } from "./i18n.js";

/** A user-facing message for an error from the API or the network. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const key = `error.${err.problem.code ?? ""}`;
    if (err.problem.code && isMessageKey(key)) return t(key);
    if (err.status === 429) return t("error.rate_limited");
    return err.problem.detail ?? err.problem.title;
  }
  // fetch rejects with a TypeError when the server cannot be reached.
  if (err instanceof TypeError) return t("error.network");
  return t("error.unexpected");
}

/** Per-field validation messages, keyed by the request field name. */
export function fieldErrors(err: unknown): Record<string, string> {
  const out: Record<string, string> = {};
  if (err instanceof ApiError) {
    for (const e of err.problem.errors ?? []) out[e.field] ??= e.detail;
  }
  return out;
}

export function errorCode(err: unknown): string | undefined {
  return err instanceof ApiError ? err.problem.code : undefined;
}

/**
 * Returns path when it is a same-origin path (where to go after signing in), otherwise "/".
 * Guards against open redirects such as "//evil.example" or "https://evil.example".
 */
export function safeRedirect(path: string | undefined): string {
  if (!path?.startsWith("/") || path.startsWith("//") || path.startsWith("/\\")) return "/";
  return path;
}
